// extracted by mini-css-extract-plugin
export var deliberationsContainer = "deliberations-module--deliberations-container--31f21";
export var deliberationsDocumentList = "deliberations-module--deliberations-document-list--27b5f";
export var deliberationsLoadingSpinner = "deliberations-module--deliberations-loading-spinner--099fa";
export var deliberationsLoadingWrapper = "deliberations-module--deliberations-loading-wrapper--fae67";
export var deliberationsMonthList = "deliberations-module--deliberations-month-list--a00c7";
export var deliberationsYearWrapper = "deliberations-module--deliberations-year-wrapper--615f9";
export var tabHidden = "deliberations-module--tab-hidden--587b5";